var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"sns-ico",style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},[_c(_setup.snsLogo,{tag:"component",attrs:{"aria-label":_vm.snsName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }